var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cart"},[_c('b',{staticClass:"topsubtitle"},[_vm._v("Electronic Device")]),_c('button',[_vm._v(_vm._s(_vm.cart.items.length)+" item(s)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }